import React from 'react';

import { SliderProvider } from './context';
import SliderItem from './Item';
import SliderNav from './Nav';

const Slider = ({ Component, items }) => {
  return (
    <SliderProvider items={items}>
      <div className="lg:-mx-3 relative flex flex-wrap lg:flex-no-wrap items-center justify-between">
        <div className="mb-6 lg:mb-0 lg:order-2 w-full">
          <SliderItem Component={Component} />
        </div>
        <SliderNav />
      </div>
    </SliderProvider>
  );
};

export default Slider;
